import { render, staticRenderFns } from "./TeamLesson.vue?vue&type=template&id=4ca7b3e6&"
import script from "./TeamLesson.vue?vue&type=script&lang=js&"
export * from "./TeamLesson.vue?vue&type=script&lang=js&"
import style0 from "./TeamLesson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TeamLesson.vue"
export default component.exports